import { css } from "@emotion/css";

interface Props {
  isVisible: boolean;
  className?: string;
}

export const LoadingOverlay = ({ isVisible, className }: Props) => {
  if (!isVisible) return null;

  return (
    <div className={`${loadingOverlayStyle} ${className || ""}`}>
      <div className={whiteShimmerStyle} />
    </div>
  );
};

const loadingOverlayStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    linear-gradient(135deg, rgba(255, 182, 193, 0.6), rgba(173, 216, 230, 0.6)),
    linear-gradient(135deg, rgba(221, 160, 221, 0.6), rgba(255, 218, 185, 0.6)),
    linear-gradient(135deg, rgba(152, 251, 152, 0.6), rgba(255, 182, 193, 0.6));
  animation: iridescent 4s ease-in-out infinite;
  pointer-events: none;
  border-radius: inherit;
  z-index: 1;

  @keyframes iridescent {
    0% {
      opacity: 0.9;
      filter: hue-rotate(0deg) saturate(1.3);
    }
    33% {
      opacity: 0.7;
      filter: hue-rotate(120deg) saturate(1.5);
    }
    66% {
      opacity: 0.8;
      filter: hue-rotate(240deg) saturate(1.4);
    }
    100% {
      opacity: 0.9;
      filter: hue-rotate(360deg) saturate(1.3);
    }
  }
`;

const whiteShimmerStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg, 
    transparent 0%, 
    rgba(255, 255, 255, 0.4) 50%, 
    transparent 100%
  );
  background-size: 200% 100%;
  animation: whiteShimmer 2s ease-in-out infinite;
  pointer-events: none;
  border-radius: 12px;

  @keyframes whiteShimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`; 